import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { T2CardComponent } from 'app/trip2-theme/components/t2-card/t2-card.component';
import { IMyOptions } from 'mydatepicker';
import { DispatchService } from 'app/pages/dispatch/dispatch.service';
import { _downloadFile } from 'app/utils/trip2-query-builder/utils/helpers';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { UsersService } from 'app/pages/users/users.service';
import { PayorsService } from 'app/pages/payors/payors.service';
import { Select2Component } from '../select2/select2.component';

@Component({
  selector: 'app-report-history',
  templateUrl: './report-history.component.html',
  styleUrls: ['./report-history.component.scss']
})
export class ReportHistoryComponent implements OnInit {

  @Input() viewBtn = true;

  @ViewChild('paramsModal') modal: T2CardComponent;
  @ViewChild('providerSelect2') providersSelect2: Select2Component;
  @ViewChild('payorSelect2') payorSelect2: Select2Component;

  providers;
  private selectedProviders = [];

  payors;
  private selectedPayors = [];

  protected myDatePickerOptions: IMyOptions = {
    dateFormat: 'yyyy-mm-dd',
    editableDateField: false
  };
  date: any;
  type = 0;

  constructor(
    private service: DispatchService,
    private loading: T2LoadingService,
    private userService: UsersService,
    private payorsService: PayorsService
    ) { }

  ngOnInit() {
    this.getProviders();
    this.getPayors();
  }

  getProviders() {
    this.userService.getProvidersForUser().subscribe(
      (provs) => {
        this.providers = provs.map((prov: any) => {
          return {
            id: prov.companyid,
            value: prov.speedcode
          };
        });
      }
    )
  }

  getPayors() {
    this.payorsService.getPayorsAll().subscribe(
      (provs) => {
        this.payors = provs.map((pay: any) => {
          return {
            id: pay.payorid,
            value: pay.description
          };
        });
      }
    )
  }

  generateReport() {
    if (this.date && this.selectedProviders.length !== 0 && this.selectedPayors.length !== 0) {
      if (this.date.formatted) {
        const spliter = this.date.formatted.split(' - ')
        if (spliter.length > 1) {
          this.loading.show();
          this.service.getReportHistory(this.selectedProviders, this.selectedPayors, spliter[0], spliter[1], this.type).finally(
            () => {
              this.loading.hiden();
            }
          ).subscribe(
            (report) => {
              _downloadFile(report.blob(), 'History-'+this.date.formatted+'.'+this.getExtension());
              this.modal.close();
              this.date = '';
              this.payorSelect2.clear();
              this.providersSelect2.clear();
            }
          )
        }

      }
    }
  }

  private getExtension() {
    switch (this.type) {
      case 0:
        return 'xlsx';
      case 1:
        return 'csv';
    }
  }

  onChangedProviderList(event) {
    this.selectedProviders = event.map((prov) => {
      return prov.id;
    })
  }

  onChangedPayor(event) {
    this.selectedPayors = event.map((pay) => {
      return pay.id;
    })
  }

  open() {
    this.modal.open();
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/report-history/report-history.component.ts